module.exports = __webpack_public_path__ + "img/a-min.d6061e0c.jpg";